<template>
  <div class="component-wrapper">
    <div class="icon1-wrapper">
      <img src="../assets/images/gift/icon1.png" class="icon1" alt="">
    </div>
    <div class="form-wrapper">
      <div class="uid-wrapper">
        <h1 class="title">Redeem Pack</h1>
        <div class="result-info" v-if="resultSuccess">
          {{ resultMessage }}
        </div>
        <div class="uid-input_wrap">
          <span>UID:</span>
          <input type="tel" placeholder="-ARKNIGHTS-" maxlength="8" oninput="value=value.replace(/[^\d]/g,''),user=''"
            v-model="uid">
          <span class="btn" @click="handleClick">Confirm</span>
        </div>
        <p class="error-message" v-show="errorMessage">{{ errorMessage }}</p>
        <p class="user-info" v-show="user">Dr. {{ user }}'s Identity Confirmed</p>
      </div>
      <div class="gift-wrapper" v-if='user'>
        <input type="text" class="code" placeholder="Redemption Code" v-model="code" minlength="16" maxlength="20"
          oninput="value=value.replace(/[^\w\/]/ig,'')" />
        <p class="error-message" v-show="codeErrorMessage">{{ codeErrorMessage }}</p>
        <span class="btn" @click="handleGetGiftClick">REDEEM</span>
      </div>
      <div class="fade" />
      <div class="info-title">
        <img src="../assets/images/gift/icon2.png" class="icon2" alt="">
        <h1>Details</h1>
      </div>
      <div class="info-content_wrapper">
        <div class="content">
          Please read and agree to the following before redeeming.
          ·Each code can only be used once.
          ·An Arknights in-game User ID must be entered.
          ·Each User ID can only receive the same reward item once.
          ·User ID is displayed below your nickname on the main page.
          ·Expired redemption codes cannot be used.
          ·Reward content may be subject to change without notice.
          ·For certain reasons, it may be necessary to suspend the issuance of redemption codes.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gift-Component',
  components: {},
  data() {
    return {
      uid: '',
      errorMessage: '',
      codeErrorMessage: '',
      resultMessage: '',
      resultSuccess: false,
      success: false,
      user: '',
      code: '',
      timerUid: null,
      timerCode: null
    }
  },
  watch: {
    uid(oldval, newval) {
      if (oldval !== newval) {
        this.errorMessage = ''
        this.user = ''
        this.codeErrorMessage = ''
      }
    },
  },
  methods: {
    async fetchUserInfo() {
      await fetch(`https://arknights.global/api/gift/playerinfo?uid=${this.uid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        if (res.status === 200) {
          res.json().then(data => {
            if (data.meta.err.code === 0) {
              this.errorMessage = ''
              const nickname = data.data.nickname;
              this.user = nickname
              clearTimeout(this.timerUid)
            } else {
              this.errorMessage = data.meta.err.msg
            }
          })
        } else {
          this.errorMessage = 'Unable to connect to server.'
        }
      }).catch(err => {
        console.log(err)
        this.errorMessage = 'Unable to connect to server.'
      })
    },
    handleClick() {
      this.user = ''
      this.code = ''
      if (this.uid == '') {
        this.errorMessage = 'Enter your User ID'
        return
      }
      if (this.uid.length > 8 || this.uid.length < 1) {
        this.errorMessage = 'Incorrect User ID'
        return
      }
      if (this.timerUid) {
        clearTimeout(this.timerUid)
      }
      this.timerUid = setTimeout(() => {
        this.fetchUserInfo()
      }, 1000)
    },
    handleGetGiftClick() {
      if (!this.user || !this.uid) return
      if (this.code === '') {
        this.codeErrorMessage = 'Enter Redemption Code'
        return
      }
      if (this.code.length < 16 || this.code.length > 20 || !(/^[0-9a-zA-Z]+$/.test(this.code))) {
        this.codeErrorMessage = 'Incorrect Redemption Code'
        return
      }
      if (this.timerCode) {
        clearTimeout(this.timerCode)
      }
      this.timerCode = setTimeout(() => {
        this.fetchGift()
      }, 1000)
    },

    fetchGift() {
      try {
        fetch('https://arknights.global/api/gift/exchange', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            uid: this.uid,
            code: this.code
          })
        }).then(res => {
          res.json().then(data => {
            if (data.meta.err.code === 0) {
              this.success = true
              this.codeErrorMessage = ''
              this.resultSuccess = true
              this.resultMessage = "Redeemed! Please check the items in the in-game email."
              let timer = setTimeout(() => {
                this.resultSuccess = false
                clearTimeout(timer)
              }, 5000)
            } else {
              this.codeErrorMessage = data.meta.err.msg
            }
          })
        }).catch(err => {
          console.log(err)
          this.codeErrorMessage = 'Unable to connect to server.'
        }
        )
      } catch (error) {

      }
    }
  },
  mounted() {

  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>
$success: #27C2DE;
$warning: #E50F0F;

.bg-red {
  background-color: $warning !important;

  &::after {
    border-color: $warning transparent transparent transparent !important;

  }
}

.component-wrapper {
  width: 652px;
  margin: 0 auto;
  margin-top: 85px;
  background: url('../assets/images/gift/bg.png') no-repeat;
  background-size: cover;
  background-position: right top;
  position: relative;
  padding: 30px 66px 68px 66px;
  box-sizing: border-box;

  .icon1-wrapper {
    display: flex;
    justify-content: center;
  }

  .icon1 {
    width: 59px;
    height: 69px;
  }

  .form-wrapper {
    .uid-wrapper {
      position: relative;
      padding-bottom: 60px;

      .result-info {
        min-width: 394px;
        height: 35px;
        line-height: 35px;
        padding-left: 10px;
        box-sizing: border-box;
        border-radius: 10px;
        letter-spacing: .08em;
        background: #27C2DE;
        position: absolute;
        top: 0;
        left: 185px;
        font-size: 12px;
        font-family: "NotoSansCJKkr_M";
        color: #fff;
        text-transform: capitalize;

        &::after {
          // cssで三角形を描画
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          left: -15px;
          bottom: 7px;
          border-style: solid;
          border-width: 16px 18px 0 0;
          border-color: #27C2DE transparent transparent transparent;
          transform: rotate(180deg);
        }
      }

      .title {
        font-size: 24px;
        color: #27C2DE;
        margin-bottom: 20px;
        font-family: "NotoSansCJKjp_B";
        text-transform: uppercase;
      }

      .uid-input_wrap {
        display: flex;
        border: 1px solid #27c2de;
        border-radius: 5px;
        align-items: center;
        justify-content: space-between;
        height: 48px;

        span {
          font-size: 18px;
          color: #27c2de;
          margin-right: 20px;
          font-family: "FOT-NewRodinProN-B";
          margin-left: 16px;
          letter-spacing: 2px;
        }

        input {
          width: 300px;
          height: 50px;
          border: none;
          border-radius: 10px;
          background: rgba(255, 255, 255, 0);
          color: #27C2DE;
          font-family: "FOT-NewRodinProN-DB";
          font-size: 18px;
          padding-left: 20px;

          &::placeholder {
            color: #177889;
            font-family: 'FOT-NewRodinProN-B';
            font-size: 18px;
            letter-spacing: 8px;
          }
        }

        .btn {
          user-select: none;
          width: 150px;
          height: 48px;
          border: none;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          background: #27C2DE;
          color: #181818;
          font-size: 20px;
          text-align: center;
          line-height: 48px;
          font-family: "NotoSansCJKkr_B";
          text-transform: uppercase;
          cursor: pointer;
          align-self: flex-end;
          justify-self: flex-end;
          margin-right: 0;
          letter-spacing: 2px;
        }
      }

      .error-message {
        position: absolute;
        color: #FF0000;
        font-size: 14px;
        font-family: 'KozGoPr6N_R';
        line-height: 1;
        margin-top: 13px;
        height: 18px;
      }

      .user-info {
        position: absolute;
        color: #27C2DE;
        font-size: 14px;
        font-family: 'KozGoPr6N_R';
        line-height: 1;
        margin-top: 13px;
        height: 18px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }
    }

    .gift-wrapper {
      // height: 14vh;
      margin-bottom: 40px;

      .error-message {
        position: absolute;
        color: #FF0000;
        font-size: 14px;
        font-family: 'KozGoPr6N_R';
        line-height: 1;
        margin-top: 13px;
        height: 18px;
        letter-spacing: 1px;
      }

      .code {
        width: 100%;
        height: 48px;
        line-height: 48px;
        border: 1px solid #27c2de;
        border-radius: 5px;
        font-family: "NotoSansCJKkr_B";
        text-transform: uppercase;
        font-size: 18px;
        background: rgba(255, 255, 255, 0);
        color: #27c2de;
        padding-left: 20px;
        box-sizing: border-box;
        letter-spacing: 1px;

        &::placeholder {
          text-align: center;
          color: #177889;
          font-size: 18px;
          height: 48px;
          line-height: 48px;
        }
      }

      .btn {
        user-select: none;
        width: 137px;
        height: 44px;
        color: #111517;
        font-size: 20px;
        font-family: "NotoSansCJKkr_B";
        background: #27C2DE;
        margin: 0 auto;
        display: block;
        text-align: center;
        line-height: 44px;
        border: none;
        cursor: pointer;
        margin-top: 51px;
        letter-spacing: 2px;
      }
    }

    .fade {
      width: 100%;
      height: 2px;
      background: #27C2DE;
      margin: 0 0 40px 0;
    }

    .info-title {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 21px 0;

      .icon2 {
        width: 16px;
        height: 22px;
        margin-right: 5px;
      }

      h1 {
        font-size: 18px;
        color: #27C2DE;
        margin-bottom: 0;
        font-family: "NotoSansCJKkr_B";
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 2px;
      }
    }

    .info-content_wrapper {
      width: 100%;
      background: #111517;
      padding: 0 28px 25px 8px;
      font-family: "NotoSansCJKkr_M";
      font-size: 14px;
      line-height: 24px;
      color: #27C2DE;
      white-space: pre-line;
      box-sizing: border-box;
      letter-spacing: 2px;

      &::-webkit-scrollbar {
        width: 13px;
      }

      &::-webkit-scrollbar-thumb {
        background: #27C2DE;
      }
    }
  }
}
</style>